import Core from '../class/Core';
import { getAllowedUrls } from '../utils/PermissionUtils';


export default (state = false, payload) => {
    let core = new Core();
    switch(payload.type){
        case 'USER_LOGIN':
            const userData = payload.data;
            const allowedUrls = getAllowedUrls(userData);

            state = {
                ...userData,
                allowedUrls
            };

            let data = payload.data.expires_in * 1000;
            data = new Date(data);
            // Salvar userData com cache para persistência no localStorage
            const userDataWithCache = {
                ...payload.data,
                allowedUrls
            };
            core.setStorage('manager_log', userDataWithCache, data);
            return state;
        case 'USER_LOGOUT':
            //bug não deletava o cookie, esta deletando direto agora
            // window.document.cookie = 'manager_log=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'

            core.removeStorage('manager_log')
            state = false;
            return state;
        case 'USER_IS_AUTH':
            state = core.getStorage('manager_log');
            if(state){
                // Recalcular cache se não existir
                if (!state.allowedUrls) {
                    state.allowedUrls = getAllowedUrls(state);
                }
                return state;
            }else{
                return false;
            }
        default:
            return state;
    }
}
